<template>
  <div style="width:100%">
    <v-card
      class="ma-3 pb-4"
      style="max-width:95%; overflow:hidden;"
      v-if="showMobileView"
    >
      <div class="d-flex justify-space-between">
        <h3 class="py-3 pl-4">{{ screenLabel.toUpperCase() }} DETAILS</h3>
      </div>
      <uptime />
      <v-row>
        <v-col class="mx-4 py-0">
          <v-select
            return-object
            v-model="currentGroup"
            :label="groupLabel"
            filled
            @input="changeGroup()"
            :items="_client.groups"
            item-text="group_name"
          />
        </v-col>
      </v-row>
      <shark-details-mobile v-if="_client.client_name === 'shark'" />
      <avis-bazzbi-details-mobile v-if="_client.client_name !== 'shark'" />
    </v-card>
    <div
      v-if="!showMobileView"
      class="d-flex justify-space-between pt-5"
      id="screen-uptime"
    >
      <v-row class="d-flex flex-wrap justify-space-between ma-0">
        <uptime style="width:calc(33.33%); height:100%; overflow:hidden;" />
        <v-card
          style="width:calc(66.66% - 24px);"
          id="screen-detail-card"
          class="ma-3"
        >
          <v-row>
            <v-col class="mx-4 py-5">
              <span style="font-size: 12px;" class="ml-3" id="screen-status">{{
                screenLabel
              }}</span>
              <div class="d-flex align-center">
                <v-icon :color="screenStatus" x-large>mdi-circle-medium</v-icon>
                <h2 v-if="_client.client_name === 'shark'">
                  {{ data.car_number }}
                </h2>
                <h2 v-else>{{ data.device_id }}</h2>
              </div>
            </v-col>
            <v-col class="mx-4 py-3" id="screen-group-dropdown">
              <v-select
                return-object
                v-model="currentGroup"
                :label="groupLabel"
                filled
                @input="changeGroup()"
                :items="_client.groups"
                :item-text="'group_name'"
              />
            </v-col>
          </v-row>
          <v-divider />
          <div class="d-flex">
            <shark-details
              v-if="_client.client_name === 'shark'"
              style="width:100%;"
            />
            <avis-bazzbi-details
              v-if="_client.client_name !== 'shark'"
              style="width:100%;"
            />
            <div style="width:132px;">
              <!-- <v-btn
                    class="white--text"
                    :class="showMobileView ? '' : 'mr-8 mt-4'"
                    :color="editable ? 'secondary' : 'primary'"
                    width="100px"
                    @click="setEdit()"
                    >{{ editable ? `Done` : `Edit` }}</v-btn
                  > -->
              <v-btn
                v-if="isAdmin"
                class="white--text"
                :class="showMobileView ? '' : 'mr-8 mt-4'"
                color="red"
                width="100px"
                id="screen-info-delete-button"
                @click="_setDeleteModal(true)"
                >Delete</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-row>
    </div>
    <current-rental-modal
      :data="data"
      :session="_currentSession"
      v-if="data.uuid && _currentSession"
    />
    <delete />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import CurrentRentalModal from '@/components/screens/CurrentRentalModal';
import Uptime from '@/components/screens/Uptime';
import AvisBazzbiDetailsMobile from '@/components/screens/detail-cards/AvisBazzbiDetailsMobile';
import SharkDetailsMobile from '@/components/screens/detail-cards/SharkDetailsMobile';
import AvisBazzbiDetails from '@/components/screens/detail-cards/AvisBazzbiDetails';
import Delete from '@/components/screens/Delete';
import SharkDetails from '@/components/screens/detail-cards/SharkDetails';
import FormatPhone from '@/mixins/FormatPhone';
import { MobileView, UserPermissions } from '@/mixins';

export default {
  name: 'ScreenDetailCard',
  components: {
    CurrentRentalModal,
    Uptime,
    AvisBazzbiDetails,
    AvisBazzbiDetailsMobile,
    SharkDetails,
    SharkDetailsMobile,
    Delete,
  },
  mixins: [ScreenDetailData, MobileView, FormatPhone, UserPermissions],
  data() {
    return {
      currentGroup: {},
    };
  },
  computed: {
    ...mapGetters({
      _userGroups: 'filters/getHomeFilterOptions',
      _client: 'account/getCurrentClient',
      _currentSession: 'screenDetails/getCurrentSession',
      _screenStatus: 'screenDetails/getScreenStatus',
    }),
    groupLabel() {
      if (this._client.client_name !== 'shark') {
        return 'Group';
      }
      return 'Course';
    },
    screenStatus() {
      if (this._client.client_name !== 'shark') {
        return this._screenStatus;
      }
      return this.data.network_status;
    },
    screenLabel() {
      if (this._client.client_name !== 'shark') {
        return 'Screen';
      }
      return 'Golf Car';
    },
    inUseLabel() {
      if (this._client.client_name !== 'shark') {
        return 'Car Status';
      }
      return 'Playing Round';
    },
  },
  methods: {
    ...mapActions({
      _uploadDetails: 'screenDetails/uploadDetails',
    }),
    ...mapMutations({
      _setDeleteModal: 'screenDetails/setDeleteModal',
    }),
    changeGroup() {
      this._uploadDetails({
        uuid: this.data.uuid,
        group_id: this.currentGroup.uuid,
      });
    },
    setEdit() {
      this.editable = !this.editable;
      if (this.editable === false) {
        this._uploadDetails();
      }
    },
  },
  watch: {
    data: {
      handler() {
        let screenGroup = null;
        this._client.groups.map(group => {
          group.group_name = group.group_name
            .toLowerCase()
            .split(' ')
            .map(s => s.charAt(0).toUpperCase() + s.substring(1))
            .join(' ');
          if (group.uuid === this.data.group_id) {
            screenGroup = group;
          }
        });
        this.currentGroup = screenGroup;
        this.currentGroup.group_name = this.currentGroup.group_name
          .toLowerCase()
          .split(' ')
          .map(s => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      },
      deep: true,
    },
  },
};
</script>
